import React, { Component } from 'react';

import _ from 'lodash';
import { TextField } from '@material-ui/core';

import { call } from 'utils';
import InputComponent from './InputComponent';

class AutoComplete extends Component {
  constructor(props) {
    super(props);

    const selectedItem = (props.items || []).find(({ id }) => id === props.value);

    this.state = {
      searchValue: selectedItem ? selectedItem.text : '',
      suggestions: [],
    };

    this.active = React.createRef();
    this.timer = React.createRef();

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
  }

  componentDidUpdate(oldProps) {
    const { value, items } = this.props;

    if (oldProps.value !== value && !this.active.current) {
      const selectedItem = (items || []).find(({ id }) => id === value);

      this.setState({
        searchValue: selectedItem ? selectedItem.text : '',
        suggestions: [],
      });
    }
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  clearTimer() {
    if (this.timer.current) {
      clearTimeout(this.timer.current);
      this.timer.current = null;
    }
  }

  fetchSuggestions(value) {
    value = value.trim().toLowerCase();
    const { items, fetch } = this.props;

    const setSuggestions = data => {
      if (Array.isArray(data)) {
        const suggestions = value
          ? data.filter(({ text }) => text.trim().toLowerCase().startsWith(value))
          : data.slice(0, 20);

        this.setState({ suggestions });
      }
    };

    if (typeof fetch === 'function') {
      const res = fetch(value);

      if (res instanceof Promise) {
        res.then(setSuggestions);
      } else {
        setSuggestions(res);
      }
    } else {
      setSuggestions(items);
    }
  }

  onSuggestionsFetchRequested({ value, reason }) {
    this.clearTimer();

    if (reason === 'input-changed') {
      this.timer.current = setTimeout(() => this.fetchSuggestions(value), 500);
    } else {
      this.fetchSuggestions(value);
    }
  }

  onSuggestionsClearRequested() {
    this.setState({ suggestions: [] });
  }

  render() {
    const { name, value, onChange, onBlur, onFocus, ...props } = this.props;
    const { searchValue, suggestions } = this.state;

    return (
      <TextField
        {..._.omit(props, ['items', 'fetch'])}
        name={`${name}_text`}
        value={searchValue}
        onChange={searchValue => this.setState({ searchValue })}
        onFocus={event => {
          this.active.current = true;
          call(onFocus, event);
        }}
        onBlur={event => {
          this.active.current = false;

          if (!value) {
            this.setState({ searchValue: '' });
          }

          call(onBlur, event);
        }}
        InputProps={{
          inputComponent: InputComponent,
          inputProps: {
            autoSuggestProps: {
              suggestions,
              renderSuggestion: ({ id, text }) => <span key={id}>{text}</span>,
              getSuggestionValue: ({ text }) => text,
              onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
              onSuggestionsClearRequested: this.onSuggestionsClearRequested,
            },
            replacedProps: { name, value, onChange },
          },
        }}
      />
    );
  }
}

export default AutoComplete;
